import { useContext } from "react";

import { apiContext } from "../contexts/api";

export function useAPI() {
  return useContext(apiContext);
}
